function unsavedReplacer(key, value) {
    if (key === 'source' || key === 'is_visible') return undefined
    return value
}

export default {
    data() {
        return {
            unsavedSnapshot: null,
            allowUnsavedLeave: false
        }
    },
    created() {
        window.addEventListener('beforeunload', this.onUnsavedBeforeUnload)
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.onUnsavedBeforeUnload)
    },
    beforeRouteLeave(to, from, next) {
        if (this.confirmUnsavedLeave()) next()
        else next(false)
    },
    methods: {
        getUnsavedState() {
            return ''
        },
        stringifyUnsaved(data) {
            return JSON.stringify(data, unsavedReplacer)
        },
        captureUnsavedSnapshot() {
            var self = this
            this.$nextTick(function () {
                self.unsavedSnapshot = self.getUnsavedState()
            })
        },
        hasUnsavedChanges() {
            if (this.allowUnsavedLeave || this.unsavedSnapshot === null) return false
            return this.getUnsavedState() !== this.unsavedSnapshot
        },
        confirmUnsavedLeave() {
            if (!this.hasUnsavedChanges()) return true
            return window.confirm('Выйти без сохранений?')
        },
        onUnsavedBeforeUnload(e) {
            if (!this.hasUnsavedChanges()) return
            e.preventDefault()
            e.returnValue = ''
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/unsavedLeaveGuard.js